/**
 * Visible FAQs, keyed by page path. The page renders them from here and schema.ts
 * emits FAQPage from the same data, so markup and page text cannot drift apart. Only add a
 * page here if the questions and answers are actually visible on it. No page has a visible FAQ
 * today, so no FAQPage is emitted.
 */
export type Faq = { q: string; a: string };

export const faqsByPath: Record<string, Faq[]> = {};
